import React, { FC, useState } from 'react';

import { TeamGameMatch } from '../../../../../database.schema';
import { MatchDayTeamGamesResultScoreCard, useFetchMatchDayTeamGamesResultScoreCard } from '../../../../api/hooks/use-fetch-match-day-results-with-scorecard';
import { useParams } from 'react-router-dom';
import { TeamGameHandicapEntry } from '../../handicaps/team-games/team-game-handicap-entry';
import { TeamGameScoreCard } from '../../score-card/team-game-score-card';
import { TeamGameHoleScores } from '../../scores/team-games/team-game-hole-scores';
type EnterTierPointsScoreCardProps = {
  editing: boolean;
};
export const EnterTeamGameScoreCard: FC<EnterTierPointsScoreCardProps> = ({ editing }): JSX.Element => {
  let params = useParams();
  const tournamentIndex = Number(params.tournamentIndex);
  const dayIndex = Number(params.dayIndex);
  const teamIndex = Number(params.teamIndex);
  const { isLoading, error, data } = useFetchMatchDayTeamGamesResultScoreCard(tournamentIndex, dayIndex);
  const { course, match, startingHole } = data as MatchDayTeamGamesResultScoreCard;
  const [recordedMatchStore, setRecordedMatchStore] = useState<TeamGameMatch>({
    ...match,
  });
  const [showHandicapEntry, setShowHandicapEntry] = useState(true);
  const [showScoreEntry, setShowScoreEntry] = useState(true);

  if (showHandicapEntry) {
    return (
      <TeamGameHandicapEntry
        editing={editing}
        startingHole={startingHole}
        matchIndex={teamIndex}
        course={course}
        recordedMatch={match}
        setRecordedMatch={setRecordedMatchStore}
        setShowHandicapEntry={setShowHandicapEntry}
        teamIndex={teamIndex}
      />
    );
  }
  if (!showHandicapEntry && showScoreEntry) {
    return (
      <TeamGameHoleScores
        startingHole={startingHole}
        recordedMatch={recordedMatchStore}
        setRecordedMatch={setRecordedMatchStore}
        course={course}
        setShowScoreEntry={setShowScoreEntry}
        teamIndex={teamIndex}
      />
    );
  }

  return (
    <TeamGameScoreCard
      startingHole={startingHole}
      course={course}
      tierPointsMatch={recordedMatchStore}
      showScoreEntry={setShowScoreEntry}
      matchIndex={dayIndex}
      teamIndex={teamIndex}
    />
  );
};
